(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-account"]) return;
  try {
    
function initWholesaleOrders(scope) {
  scope.querySelectorAll('[data-ud-orders]').forEach((root) => {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const search = root.querySelector('[data-ud-search]');
    const filter = root.querySelector('[data-ud-filter]');
    if (!search || !filter) return;
    const cards = Array.from(root.querySelectorAll('[data-ud-order]'));
    const indexes = cards.map(card => (card.dataset.searchText + ' ' + card.textContent).toLocaleLowerCase());
    const update = () => {
      const term = search.value.trim().toLocaleLowerCase();
      let count = 0;
      cards.forEach((card, index) => {
        const matches = (filter.value === 'all' || card.dataset.state === filter.value) && indexes[index].includes(term);
        card.hidden = !matches;
        if (matches) count += 1;
      });
      root.querySelector('[data-ud-empty]').hidden = count !== 0;
    };
    search.addEventListener('input', update);
    filter.addEventListener('change', update);
    root.querySelector('[data-ud-controls]').hidden = false;
  });
}
initWholesaleOrders(document);
document.addEventListener('shopify:section:load', () => initWholesaleOrders(document));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tbo-faire-band"] && !Shopify.designMode) return;
  try {
    
// Faire reviews ticker: constant speed (px/s) whatever the number of reviews; pauses while hovered (CSS).
document.querySelectorAll('.tbo-faire-band .ud-rv').forEach(rv => {
  const track = rv.querySelector('.ud-rv__track'); if (!track) return;
  const speed = matchMedia('(max-width:799px)').matches ? 55 : 80; // ponytail: fixed px/s, make it a section setting if anyone asks
  const fit = () => rv.style.setProperty('--ud-rv-dur', Math.max(12, (track.scrollWidth / 2) / speed) + 's');
  fit(); addEventListener('resize', fit, {passive: true});
});
if (!customElements.get('ud-faire-widget')) {
  customElements.define('ud-faire-widget', class extends HTMLElement {
    connectedCallback() {
      if (this.querySelector('iframe') || this.observer) return;
      const load = () => {
        const template = this.querySelector('template');
        if (!template) return;
        this.appendChild(template.content.cloneNode(true));
        template.remove();
        this.observer?.disconnect();
      };
      if (!('IntersectionObserver' in window) || window.Shopify?.designMode) {
        load();
        return;
      }
      this.observer = new IntersectionObserver(entries => {
        if (entries.some(entry => entry.isIntersecting)) load();
      }, {rootMargin: '600px 0px'});
      this.observer.observe(this);
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.observer = null;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ud-home-cinema"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-ud-hc]').forEach(function (el) {
  if (el.dataset.ready) return; el.dataset.ready = '1';
  // The chat launcher waits until the hero leaves the screen (layout/theme.liquid hides it under .ud-hc-in).
  if ('IntersectionObserver' in window) new IntersectionObserver(function (e) { document.documentElement.classList.toggle('ud-hc-in', e[0].isIntersecting); }, { threshold: 0.35 }).observe(el);
  var stage = el.querySelector('[data-stage]');
  var bands = [].slice.call(stage.querySelectorAll('.ud-hc__band'));
  var words = [].slice.call(el.querySelectorAll('.ud-hc__word'));
  var n = words.length, i = 0, timer = null, prevTimer = null, paused = false;
  var count = el.querySelector('[data-count]'), btn = el.querySelector('[data-btn]'), pause = el.querySelector('[data-pause]');
  var speed = (parseInt(el.dataset.speed, 10) || 5) * 1000;
  // tbo.motion bands: pieces drop in the first time the band shows, then flip one at a time to the on-model photo.
  var mBands = bands.filter(function (b) { return b.classList.contains('ud-hc__band--motion'); });
  if (mBands.length) {
    var still = matchMedia('(prefers-reduced-motion: reduce)').matches;
    var mSeen = function () { mBands.forEach(function (b) { if (b.classList.contains('is-on')) b.classList.add('is-in'); }); };
    requestAnimationFrame(function () { requestAnimationFrame(mSeen); });
    if (!still) setInterval(function () {
      mSeen();
      var p = el.querySelector('[data-pause]');
      if (document.hidden || (p && p.getAttribute('aria-pressed') === 'true')) return;
      mBands.forEach(function (b) {
        if (!b.classList.contains('is-on')) return;
        var ts = b.querySelectorAll('.ud-hc__mtile'); if (!ts.length) return;
        b._mi = (b._mi || 0) + 1; var t = ts[b._mi % ts.length];
        var w = t.parentNode; w.classList.add('is-open'); t.classList.add('is-flip');
        setTimeout(function () { t.classList.remove('is-flip'); }, 2400);
        setTimeout(function () { w.classList.remove('is-open'); }, 3400);
      });
    }, 1300);
  }
  if (n < 2) return;
  function paint(from) {
    bands.forEach(function (b, k) {
      b.classList.toggle('is-on', k === i);
      b.classList.toggle('is-prev', k === from && k !== i);
      b.toggleAttribute('inert', k !== i);
    });
    clearTimeout(prevTimer);
    prevTimer = setTimeout(function () { bands.forEach(function (b) { b.classList.remove('is-prev'); }); }, 1300);
    words.forEach(function (x, k) { x.classList.toggle('is-on', k === i); });
    if (count) count.textContent = String(i + 1).padStart(2, '0') + ' / ' + String(n).padStart(2, '0');
    if (btn) btn.setAttribute('href', words[i].dataset.url || '#');
    el.classList.toggle('ud-hc--bf', /\/black-friday-3-days-only(\?|$)/.test(words[i].dataset.url || ''));
  }
  function go(k) { var from = i; i = (k + n) % n; if (from !== i) paint(from); restart(); }
  function tick() { if (paused || document.hidden || el.matches(':hover') || el.contains(document.activeElement)) return; var from = i; i = (i + 1) % n; paint(from); }
  function restart() { clearInterval(timer); if (!paused) timer = setInterval(tick, speed); }
  var prev = el.querySelector('[data-prev]'), next = el.querySelector('[data-next]');
  if (prev) prev.addEventListener('click', function () { go(i - 1); });
  if (next) next.addEventListener('click', function () { go(i + 1); });
  if (pause) pause.addEventListener('click', function () {
    paused = !paused; pause.setAttribute('aria-pressed', String(paused));
    pause.setAttribute('aria-label', paused ? 'Play slideshow' : 'Pause slideshow'); restart();
  });
  if (matchMedia('(prefers-reduced-motion: reduce)').matches && pause) { paused = true; pause.setAttribute('aria-pressed', 'true'); pause.setAttribute('aria-label', 'Play slideshow'); }
  var sx = null;
  stage.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
  stage.addEventListener('touchend', function (e) { if (sx == null) return; var dx = e.changedTouches[0].clientX - sx; if (Math.abs(dx) > 40) go(dx < 0 ? i + 1 : i - 1); sx = null; }, { passive: true });
  bands.forEach(function (b, k) { b.toggleAttribute('inert', k !== i); });
  restart();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ud-interface-grid"]) return;
  try {
    
if (!customElements.get('ud-interface-filter-context')) {
 customElements.define('ud-interface-filter-context', class extends HTMLElement {
  connectedCallback() {
   const view = this.dataset.view;
   if (!view) return;
   customElements.whenDefined('facet-filters-form').then(() => {
    if (!this.isConnected) return;
    const Form = customElements.get('facet-filters-form');
    if (Form.udInterfaceContext) return;
    Form.udInterfaceContext = true;
    const render = Form.renderPage;
    Form.renderPage = function(searchParams, event, updateURLHash = true) {
     const query = new URLSearchParams(searchParams);
     query.set('view', view);
     return render.call(this, query.toString(), event, updateURLHash);
    };
   });
  }
 });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ud-interface-login"]) return;
  try {
    
if (!customElements.get('ud-interface-password-toggle')) {
 customElements.define('ud-interface-password-toggle', class extends HTMLElement {
  connectedCallback() {
   const button = this.querySelector('button');
   const input = this.closest('.field').querySelector('input');
   if (!button || !input || this.ready) return;
   this.ready = true;
   button.hidden = false;
   button.addEventListener('click', () => {
    const shown = input.type === 'password';
    input.type = shown ? 'text' : 'password';
    button.setAttribute('aria-pressed', String(shown));
    button.textContent = shown ? button.dataset.hide : button.dataset.show;
   });
  }
 });
}

  } catch(e) { console.error(e); }
})();
})();
